
<template>
    <div class="container-fluid">
        <div class="col-md-12">
            <p><b>Nom :</b> {{ adh.fullname }}</p>
            <p><b>Portable :</b> <a :href="`tel:${adh.mobile}`"> {{ adh.mobile }}</a></p>
            <p><b>Fixe :</b> <a :href="`tel:${adh.tel}`"> {{ adh.tel }}</a></p>
            <p><b>Adresse mail :</b> <a :href="`mailto:${adh.email}`"> {{ adh.email }}</a></p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'UserGroupEditList',
    components: {
        
    },
    props: {
        adh_id: {
            type: Number,
            required: true,
            default: function () {
                return {
                    id: 1
                }
            }
        }
    },
    data () {
        return {
            adh :{
                fullname : "",
                mobile : "",
                tel : "",
                email : "",
            }
        };
    },
    computed: {
        ...mapGetters({
            adherentById: 'adherents/adherentById',
        })
    },
    mounted() {
		this.adh = this.adherentById(this.adh_id);
    },
    methods: {
        
        show(adh) {
            this.adh_info=adh;
        },

        closeModal(e) {
            // Prevent modal from closing
            e.preventDefault()
            // Trigger submit handler
            this.handleSubmit()
        },
    },
};
</script>